module.exports = __webpack_public_path__ + "static/media/6.dbe6a5b3.jpg";